import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=7b28a61e"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b28a61e')) {
      api.createRecord('7b28a61e', component.options)
    } else {
      api.reload('7b28a61e', component.options)
    }
    module.hot.accept("./PaymentMethods.vue?vue&type=template&id=7b28a61e", function () {
      api.rerender('7b28a61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/PaymentMethods.vue"
export default component.exports